import React, { FC } from 'react';
import styles from '../LandingPageStep.scss';
import clsx from 'clsx';
import LpMain from 'assets/svgs/lp-main.svg';
import { LandingPageStepContent } from './LandingPageStepContent';

export const LandingPageStepDesktop: FC = () => {
  return (
    <div className={styles.landingPageStep}>
      <div className={styles.landingPageStepContainer}>
        <div className={styles.landingPageStepSide}>
          <img
            className={clsx(styles.landingPageStepImage, styles.left)}
            src="https://static.wixstatic.com/media/0784b1_beb8d7eb3b174cb7aaeb8037e8bc11d7~mv2.webp"
            alt="Landing Page Step"
          />
        </div>
        <div className={styles.landingPageStepContentWrapper}>
          <LpMain className={styles.landingPageStepContentBg} />
          <LandingPageStepContent />
        </div>
        <div className={styles.landingPageStepSide}>
          <img
            className={clsx(styles.landingPageStepImage, styles.right)}
            src="https://static.wixstatic.com/media/0784b1_a8d58eb9846c4d44aec097317146dbbb~mv2.webp"
            alt="Landing Page Step"
          />
        </div>
      </div>
    </div>
  );
};
